<mat-dialog-content>
    <p class="mat-typography">Config export:</p>
    <textarea #textBox readonly="readonly" class="config-text-box">
    {{ configText }}
    </textarea>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button (click)="textBox.focus();textBox.select()">Select all</button>
    <button mat-flat-button color="primary" (click)="copyText()">Copy config</button>
</mat-dialog-actions>